import { __decorate } from "tslib";
import { Api } from '@/domains/api';
import { Module, MutationAction, VuexModule } from 'vuex-module-decorators';
let RoomStore = class RoomStore extends VuexModule {
    constructor() {
        super(...arguments);
        this.rooms = [];
        this.roomDetail = null;
    }
    async fetch(controllerId) {
        const response = await Api.Rooms.Get(controllerId);
        return {
            rooms: response.data,
        };
    }
    async fetchRoomDetail(payload) {
        const response = await Api.Rooms.GetRoomDetail(payload.controllerId, payload.roomId);
        return {
            roomDetail: response.data,
        };
    }
};
__decorate([
    MutationAction({ mutate: ['rooms'] })
], RoomStore.prototype, "fetch", null);
__decorate([
    MutationAction({ mutate: ['roomDetail'] })
], RoomStore.prototype, "fetchRoomDetail", null);
RoomStore = __decorate([
    Module({
        namespaced: true,
    })
], RoomStore);
export default RoomStore;
